import { begriffBezeichnung, begriffAic, begriffTooltip, globalsAic, globalsKennung, globalsStt, globalsFrame, globalsAufgaben,
  globalsLayout, globalsDruck, globalsAmpel, globalsModellFarbe } from "@/local";

export enum Globals {
  Begriff,
  Einheit,
  Code,
  Mandanten,
  Stt,
  Druck,
  Layout,
  Ampel,
  Aufgabe,
  Node
}

export class StaticGlobals {
  public static Current = { begriffBezeichnung, begriffAic, begriffTooltip, globalsAic, globalsKennung, globalsStt, globalsFrame, globalsAufgaben,
    globalsLayout, globalsDruck, globalsAmpel, globalsModellFarbe };
}
